import { render } from "./MasterDataRowsView.vue?vue&type=template&id=52c9cc10&scoped=true&ts=true"
import script from "./MasterDataRowsView.vue?vue&type=script&lang=ts"
export * from "./MasterDataRowsView.vue?vue&type=script&lang=ts"

import "./MasterDataRowsView.vue?vue&type=style&index=0&id=52c9cc10&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52c9cc10"]])

export default __exports__